"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserIcons = void 0;
var _react = _interopRequireDefault(require("react"));
var _PlusIcon = _interopRequireDefault(require("calcite-ui-icons-react/PlusIcon"));
var _ActionButtonListStyled = require("./ActionButtonList-styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; } // import GroupIcon from "calcite-ui-icons-react/GroupIcon";
/* Action to represent generic indication that items belong to group(s). This will be used when table column is narrow.

const groupSummaryAction = {
  icon: (
    <GroupIcon
      size={16}
      style={{ height: "100%", display: "flex", alignItems: "center" }}
    />
  ),
  label: "Shared with groups",
  onClick: (item) => console.log(item),
  id: "group-collapsed",
};
*/

var getUserIcons = function getUserIcons(_ref) {
  var actions = _ref.actions,
    itemGroups = _ref.itemGroups;
  var userIconsArr = _toConsumableArray(actions);

  // If item belongs to any groups
  if (itemGroups === null || itemGroups === void 0 ? void 0 : itemGroups.length) {
    var plusAction = {
      id: "plus",
      icon: /*#__PURE__*/_react.default.createElement(_PlusIcon.default, {
        size: 14,
        style: {
          margin: "0 0.15rem"
        }
      })
    };

    // First add plus icon
    userIconsArr.push(plusAction);
    itemGroups.forEach(function (itemGroup, index) {
      var itemGroupIcon = {
        icon: /*#__PURE__*/_react.default.createElement(_ActionButtonListStyled.StyledSharedGroupIcon, {
          groupIndex: index
        }, itemGroup.groupLetter),
        label: itemGroup.groupTitle,
        onClick: function onClick(item) {
          return console.log(item);
        },
        id: itemGroup.groupId
      };

      // Add icon for each group that displays the first letter in group title
      userIconsArr.push(itemGroupIcon);
    });
  }
  return userIconsArr.map(function (action, i) {
    return action.id === "plus" ? /*#__PURE__*/_react.default.createElement(_ActionButtonListStyled.StyledSpan, {
      key: "".concat(action.id, "-").concat(i)
    }, action.icon) : /*#__PURE__*/_react.default.createElement(_ActionButtonListStyled.StyledTooltipWrapper, {
      key: "".concat(action.id, "-").concat(i)
    }, /*#__PURE__*/_react.default.createElement(_ActionButtonListStyled.StyledTooltip, {
      title: action.label,
      appendToBody: true
    }, action.icon));
  });
};
exports.getUserIcons = getUserIcons;